export default __webpack_public_path__ + "static/media/explore_sample_plans.a2c0470b.png";